import {
	AssessmentQueryInfo,
	checkExtension,
	isAssessmentVerityEnabledFromInfo,
	isVerityLockdown,
	isVersionSupported,
} from "./helpers";

export async function checkReturnToAssessmentStart({
	assessmentInfo,
	extensionConnectIframe,
	checkVerityEnabledFallback,
}: {
	assessmentInfo: AssessmentQueryInfo;
	extensionConnectIframe: HTMLIFrameElement;
	checkVerityEnabledFallback?: () => Promise<boolean> | boolean;
}) {
	if (await isVerityLockdown(extensionConnectIframe)) {
		return false;
	}

	const { instituteId, lmsProvidedCourseId, lmsProvidedAssessmentId, assessmentType } = assessmentInfo;
	let verityEnabled: boolean;
	if (instituteId != null && lmsProvidedCourseId && lmsProvidedAssessmentId) {
		verityEnabled = await isAssessmentVerityEnabledFromInfo({
			extensionConnectIframe,
			instituteId,
			lmsProvidedCourseId,
			lmsProvidedAssessmentId,
			assessmentType,
		});
	} else {
		verityEnabled = (await checkVerityEnabledFallback?.()) ?? false;
	}

	if (!verityEnabled) {
		return false;
	}
	const checkExtensionRes = await checkExtension(extensionConnectIframe).catch(() => {
		return { exists: false, version: undefined };
	});
	return (
		!checkExtensionRes.exists ||
		(checkExtensionRes.version && !(await isVersionSupported(extensionConnectIframe, checkExtensionRes.version)))
	);
}
